import { APITypes } from '../primary-record-types';
import getName from './getName';

export const isUserCollaborator = (
    collaborator: APITypes.medicalProfileService.MedicalProfileCollaborator,
): collaborator is APITypes.medicalProfileService.MedicalProfileUserCollaborator => {
    return collaborator.type === 'user-collaborator';
};

export const isOrganizationCollaborator = (
    collaborator: APITypes.medicalProfileService.MedicalProfileCollaborator,
): collaborator is APITypes.medicalProfileService.MedicalProfileOrganizationCollaborator => {
    return collaborator.type === 'organization-collaborator';
};

export const getCollaboratorName = (
    collaborator: APITypes.medicalProfileService.MedicalProfileCollaborator,
): string => {
    return isUserCollaborator(collaborator) ? getName(collaborator.user) : collaborator.organization.metadata.name;
};
